<template>
  <Modal
          v-model="_value"
          width="500"
          title="BSJ设置车辆参数"
          @on-visible-change="visibleChange"
          ok-text="关闭"
          cancel-text="">
    <Form ref="setupVehicleParams" autoComplete="on" v-model="setupVehicleParams"
          class="card-box login-form">
      <FormItem>
        <label>注：如不修改的字段请留空</label>
      </FormItem>
      <FormItem prop="driverCardNum">
        <label style="display: inline-block; width: 100px;">司机卡号</label>
        <Input style="display: inline-block;" v-model="setupVehicleParams.driverCardNum"
               placeholder="请输入司机卡号">
        </Input>
      </FormItem>
      <FormItem prop="driverLicenseNum">
        <label style="display: inline-block; width: 100px;">驾驶证号</label>
        <Input style="display: inline-block;" v-model="setupVehicleParams.driverLicenseNum"
               placeholder="请输入驾驶证号">
        </Input>
      </FormItem>
      <FormItem prop="driverName">
        <label style="display: inline-block; width: 100px;">驾驶员名</label>
        <Input style="display: inline-block;" v-model="setupVehicleParams.driverName"
               placeholder="请输入驾驶员名">
        </Input>
      </FormItem>
      <FormItem prop="vin">
        <label style="display: inline-block; width: 100px;">车架号</label>
        <Input style="display: inline-block;" v-model="setupVehicleParams.vin" placeholder="请输入车架号">
        </Input>
      </FormItem>
      <FormItem prop="registrationNum">
        <label style="display: inline-block; width: 100px;">车牌号</label>
        <Input style="display: inline-block;" v-model="setupVehicleParams.registrationNum"
               placeholder="请输入车牌号">
        </Input>
      </FormItem>
      <FormItem prop="vehicleTypeName">
        <label style="display: inline-block; width: 100px;">车牌分类</label>
        <Input style="display: inline-block;" v-model="setupVehicleParams.vehicleTypeName"
               placeholder="请输入车牌分类">
        </Input>
      </FormItem>
      <FormItem prop="engineNum">
        <label style="display: inline-block; width: 100px;">发动机号</label>
        <Input style="display: inline-block;" v-model="setupVehicleParams.engineNum"
               placeholder="请输入发动机号">
        </Input>
      </FormItem>
      <Button type="primary" @click="onCleanVehicleParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSetupVehicleParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import store from '@/store'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

  function getWordsCount (val) {
    var bytesCount = 0
    for (var i = 0; i < val.length; i++) {
      var c = val.charAt(i)
      if (/^[\u0000-\u00ff]$/.test(c)) // 匹配双字节
      {
        bytesCount += 1
      } else {
        bytesCount += 2
      }
    }
    return bytesCount
  }
  export default {
    name: 'bsjsetvehicleparametersmodal',
    props: {
      initValue: null,
      terminalNumValue: null,
      value: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        setupVehicleParams: {
          id: null,
          driverCardNum: null, // 司机卡号
          driverLicenseNum: null, // 驾驶证代码
          driverName: null, // 驾驶员名
          vin: null, // 车架号
          registrationNum: null, // 车牌号
          vehicleTypeName: null, // 车牌分类
          engineNum: null,// 发动机号
        },
        registrationNumTypeOptions:[
          {label:'小型车辆', value: '1'},
          {label:'大型车辆', value: '2'},
          {label:'挂车', value: '3'},
        ],

      }
    },
    methods: {
      ...mapActions([
      ]),
      visibleChange (val) {
        if (val) {
          this.setupVehicleParams.id = this._initValue
          this.setupVehicleParams.driverCardNum = null
          this.setupVehicleParams.driverLicenseNum = null
          this.setupVehicleParams.driverName = null
          this.setupVehicleParams.vin = null
          this.setupVehicleParams.registrationNum = null
          this.setupVehicleParams.vehicleTypeName = null
          this.setupVehicleParams.engineNum = null
            store.dispatch('PositioningDeviceInfoServ_SearchByName',{
                params:{
                    name: this._terminalNumValue
                },
                urlparams:null,
            }).then(res =>{
                if (store.getters.get_PositioningDeviceInfo_SearchByNameResult && store.getters.get_PositioningDeviceInfo_SearchByNameResult.length >0){
                    console.log(store.getters.get_PositioningDeviceInfo_SearchByNameResult)
                    let vehicleInfoId = store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].vehicleInfoId
                    if (vehicleInfoId!=null){
                      store.dispatch('VehicleInfoServ_GetDetail',{
                        params:{
                          id: vehicleInfoId
                        },
                        urlparams:null
                      }).then(res =>{
                        if (store.getters.get_VehicleInfo_GetDetailResult){
                          let vehicleInfo = store.getters.get_VehicleInfo_GetDetailResult
                          this.setupVehicleParams.vin = vehicleInfo.vin
                          this.setupVehicleParams.registrationNum = vehicleInfo.registrationNum
                          if (vehicleInfo.vehicleType != null){
                            this.setupVehicleParams.vehicleTypeName = vehicleInfo.vehicleType.name
                          }
                          this.setupVehicleParams.engineNum = vehicleInfo.engineNum
                        }
                      }).catch(err =>{

                      })

                    } else {
                        console.log(store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].installOrderId)
                        store.dispatch('InstallOrderServ_GetDetail',{
                            params:{
                                id: store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].installOrderId
                            },
                            urlparams:null
                        }).then(res =>{
                            if (store.getters.get_InstallOrder_GetDetailResult){
                                let installOrder = store.getters.get_InstallOrder_GetDetailResult
                                this.setupVehicleParams.vin = installOrder.tempVehicleInfo.vin
                                this.setupVehicleParams.registrationNum = installOrder.tempVehicleInfo.registrationNum
                                if (installOrder.tempVehicleInfo.vehicleType != null){
                                    this.setupVehicleParams.vehicleTypeName = installOrder.tempVehicleInfo.vehicleType.name
                                }
                                this.setupVehicleParams.engineNum = installOrder.tempVehicleInfo.engineNum
                            }
                        }).catch(err =>{

                        })
                    }
                }
            }).catch(err =>{

            })
        }
      },
      onSetupVehicleParams () {
        let cmd = '<EXTBE1'
        if (this.setupVehicleParams.driverCardNum) {
          let driverCardNum = this.setupVehicleParams.driverCardNum
          let spaceCount = 7 - getWordsCount(driverCardNum)
          if (spaceCount > 0) {
            for (var i = 0; i < spaceCount; i++) {
              driverCardNum = driverCardNum + ' '
            }
          }
          cmd = cmd + driverCardNum + ','
        } else {
          cmd = cmd + ','
        }
        if (this.setupVehicleParams.driverLicenseNum) {
          let driverLicenseNum = this.setupVehicleParams.driverLicenseNum
          let spaceCount = 18 - getWordsCount(driverLicenseNum)
          if (spaceCount > 0) {
            for (var i = 0; i < spaceCount; i++) {
              driverLicenseNum = driverLicenseNum + ' '
            }
          }
          cmd = cmd + driverLicenseNum + ','
        } else {
          cmd = cmd + ','
        }
        if (this.setupVehicleParams.driverName) {
          let driverName = this.setupVehicleParams.driverName
          let spaceCount = 10 - getWordsCount(driverName)
          if (spaceCount > 0) {
            for (var i = 0; i < spaceCount; i++) {
              driverName = driverName + ' '
            }
          }
          cmd = cmd + driverName + ','
        } else {
          cmd = cmd + ','
        }
        if (this.setupVehicleParams.vin) {
          let vin = this.setupVehicleParams.vin
          let spaceCount = 17 - getWordsCount(vin)
          if (spaceCount > 0) {
            for (var i = 0; i < spaceCount; i++) {
              vin = vin + ' '
            }
          }
          cmd = cmd + vin + ','
        } else {
          cmd = cmd + ','
        }
        if (this.setupVehicleParams.registrationNum) {
          let registrationNum = this.setupVehicleParams.registrationNum
          let spaceCount = 12 - getWordsCount(registrationNum)
          if (spaceCount > 0) {
            for (var i = 0; i < spaceCount; i++) {
              registrationNum = registrationNum + ' '
            }
          }
          cmd = cmd + registrationNum + ','
        } else {
          cmd = cmd + ','
        }
        if (this.setupVehicleParams.vehicleTypeName) {
          let vehicleTypeName = this.setupVehicleParams.vehicleTypeName
          let spaceCount = 12 - getWordsCount(vehicleTypeName)
          if (spaceCount > 0) {
            for (var i = 0; i < spaceCount; i++) {
              vehicleTypeName = vehicleTypeName + ' '
            }
          }
          cmd = cmd + vehicleTypeName + ','
        } else {
          cmd = cmd + ','
        }
        if (this.setupVehicleParams.engineNum) {
          cmd = cmd + this.setupVehicleParams.engineNum + ','
        } else {
          cmd = cmd + ','
        }
        if (this.setupVehicleParams.driverLicenseNum) {
          let driverLicenseNum = this.setupVehicleParams.driverLicenseNum
          let spaceCount = 18 - getWordsCount(driverLicenseNum)
          if (spaceCount > 0) {
            for (var i = 0; i < spaceCount; i++) {
              driverLicenseNum = driverLicenseNum + ' '
            }
          }
          cmd = cmd + driverLicenseNum
        }
        cmd = cmd + 'AA>'
        store.dispatch('NetCommandServ_SendCommand', {
          params: { id: this.setupVehicleParams.id, content: cmd, urgent:true  }
        }).then(() => {
          this.$Message.success('发送成功')

          // store.dispatch('NetCommandServ_SendCommand', {
          //   params: { id: this._initValue, content: '<EXTBE0>', urgent: true }
          // }).then(() => {
          //   this.$Message.success('采集车辆信息，发送成功')
          // }).catch(err => {
          //   this.$Message.error(err)
          // })

          let queryParams = []
          queryParams.push(genQueryParam('terminalNum', 'EQ', this._terminalNumValue))
          store.dispatch('DriverCardDataResultServ_GetPage', {
            params: null,
            urlparams: {
              q: queryParams
            }
          }).then(res => {
            // console.log(res)
            if (store.getters.get_DriverCardDataResult_GetPageResult) {
              // console.log(store.getters.get_DriverCardDataResult_GetPageResult)
              let driverCardDataResults = store.getters.get_DriverCardDataResult_GetPageResult.content
              for (let i = 0; i < driverCardDataResults.length; i++) {
                if (driverCardDataResults[i].processState != 3) {
                  driverCardDataResults[i].processRemark = '写卡'
                  driverCardDataResults[i].processState = 3
                  store.dispatch('DriverCardDataResultServ_AddProcessRemark', {
                    params: driverCardDataResults[i]
                  }).then(() => {
                    // this.refreshPage()
                  }).catch(err => {
                    this.$Message.error(err)
                  })
                }
              }
            }
          }).catch(err => {
            console.log(err)
          })
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      onCleanVehicleParams () {
        // this.setupVehicleParams.id = null
        this.setupVehicleParams.driverCardNum = null
        this.setupVehicleParams.driverLicenseNum = null
        this.setupVehicleParams.driverName = null
        this.setupVehicleParams.vin = null
        this.setupVehicleParams.registrationNum = null
        this.setupVehicleParams.vehicleTypeName = null
        this.setupVehicleParams.engineNum = null
      },
    },
    computed: {
      _value: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get () {
          return this.initValue
        },
        set (val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _terminalNumValue: {
        get () {
          return this.terminalNumValue
        },
        set (val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted () {
      this.$nextTick(() => {

      })
    }
  }
</script>
